import * as React from 'react'
import { TerminalNodeInterpreter } from '../model/TerminalNodeInterpreter';
import { TerminalScoreContext } from '../TerminalScoreProvider';
import TerminalStat from './TerminalStat';


type Props = {
  nodeId: string,
  className?: string
}


const TerminalUptimeProblem: React.FC<Props> = ({ nodeId, className = '' }) => {
  const { graph, terminalScore } = React.useContext(TerminalScoreContext);

  const graphNode = graph.getNode(nodeId);
  const terminalNode = terminalScore.getNode(nodeId);
  const interpreter = new TerminalNodeInterpreter(terminalNode);
  const status = terminalScore.getNodeStatus(nodeId);

  let isMatch: boolean|undefined = undefined;
  let value = '-';
  if (status === 'unstable' && interpreter.unstableError === 'fail_uptime_ratio') {
    value = 'fail';
    isMatch = false;
  } else if (status === 'stable' || status === 'scored') {
    value = 'ok';
    isMatch = true;
  }



  return (
    <TerminalStat label="Uptime ratio" value={value} isMatched={isMatch} />
  );
}

export default TerminalUptimeProblem;

